// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveAction_removeButton__L7OSq"};